import { GET_FAQ } from "@/app/Api/Route_API";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/utils/axiosInstance";

export const getFaqsList = createAsyncThunk(
  "faqs/getFaqsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(GET_FAQ);

      if (response?.data?.status === true) {
        return response?.data?.data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const FaqSlice = createSlice({
  name: "faqs",
  initialState: {
    faqs: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFaqsList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getFaqsList.fulfilled, (state, action) => {
        state.faqs = action.payload;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(getFaqsList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default FaqSlice.reducer;
